import { Select } from "components"
import { useProjectList } from "pages/Finance/Transaction/GeneralEntry/utils/hooks"
import { DetailFormType } from "pages/Purchase/Transaction/EnterBill/utils"
import { Fragment } from "react"
import { Controller, useFormContext } from "react-hook-form"


export const DropdownJobs = () => {
    const { control, setValue } = useFormContext<DetailFormType>()
    const jobs = useProjectList()

    return (
        <Fragment>
            <Controller
                control={control}
                name="project_id"
                render={({ field, fieldState }) => {
                    return (
                        <section>
                            <Select
                                placeholder="Select Jobs"
                                error={fieldState.error?.message}
                                ref={field.ref}
                                options={jobs.dropdown}
                                value={
                                    field.value
                                        ? jobs.dropdown.find(
                                            (item) => item.value === field.value.toString()
                                        )
                                        : null
                                }
                                onChange={(e) => {
                                    field.onChange(e?.value)
                                    setValue("project_name", e?.label ?? "")
                                }}
                            />
                        </section>
                    )
                }}
            />
        </Fragment>
    )
}
